export default {"src":"/_next/static/media/mp.76bea08a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};